import React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const NewCheckboxInput2 = ({ dataText, checkedValues, handleCheck }) => {
    return (
        <div>
            {dataText.map((item, i) => (
                <div key={i}>
                    <FormGroup>
                        <FormControlLabel
                            className="SFRadioInput"
                            labelPlacement="start"
                            control={
                                <Checkbox
                                    id={item.id}
                                    checked={checkedValues[item.id] || false}
                                    onChange={handleCheck}
                                />
                            }
                            label={<span className="SFCheckboxLabel">{item.label}</span>}
                        />
                    </FormGroup>
                </div>
            ))}
        </div>
    );
};

export default NewCheckboxInput2;
